"use client";

import * as React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const inquiries = [{
  question: "What is the typical investment horizon for N2N Capital's infrastructure funds?",
  answer: "Our funds are structured with a long-term perspective, typically targeting a 7 to 10-year horizon. This aligns with the capital-intensive nature of developing and scaling foundational AI assets like hyperscale data centers and GPU clusters."
}, {
  question: "How do you evaluate the energy efficiency of prospective data center investments?",
  answer: "Rigorous due diligence is applied to Power Usage Effectiveness (PUE) metrics, cooling technologies (such as liquid cooling), and access to renewable energy sources. Sustainable infrastructure is critical to long-term value creation and operational viability."
}, {
  question: "What is the minimum commitment for institutional limited partners?",
  answer: "We target institutional investors and tech-savvy limited partners. The standard minimum commitment for our primary infrastructure fund is $10 million, though we occasionally offer co-investment vehicles with adjusted thresholds."
}, {
  question: "Do you co-invest in edge computing facilities alongside traditional GPU farms?",
  answer: "Yes. While massive centralized GPU farms form the core of our portfolio, we actively allocate capital to edge data center projects that reduce latency for real-time AI inference applications."
}, {
  question: "How is the portfolio's exposure to hardware obsolescence managed?",
  answer: "We mitigate hardware risk through strategic leasing structures, partnerships with tier-one hardware vendors, and a focus on adaptable facility designs that can accommodate multiple generations of compute architecture."
}];
export default function CommonInquiries() {
  return <section id="common-inquiries" className="bg-background text-foreground py-24 px-6 lg:px-8 relative overflow-hidden border-t border-border/10">
      {}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,var(--border)_1px,transparent_1px),linear-gradient(to_bottom,var(--border)_1px,transparent_1px)] bg-[size:48px_48px] opacity-[0.03] pointer-events-none" />

      <div className="max-w-4xl mx-auto relative z-10">
        <div className="mb-16 md:mb-24">
          <div className="inline-block px-3 py-1 mb-8 border border-border bg-secondary text-[10px] font-mono tracking-[0.2em] uppercase text-foreground">
            Parameters & Criteria
          </div>
          <h2 className="text-4xl md:text-6xl font-sans font-bold tracking-tighter mb-8 text-foreground uppercase">
            Common <br />
            <span className="text-accent">Inquiries</span>
          </h2>
          <p className="text-foreground/70 font-serif text-lg md:text-xl max-w-2xl leading-relaxed">
            Operational parameters, fund structures, and technical specifications for our institutional AI infrastructure investments.
          </p>
        </div>
        
        <div className="border-t border-border">
          <Accordion type="single" collapsible className="w-full">
            {inquiries.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-b border-border rounded-none">
                <AccordionTrigger className="rounded-none hover:no-underline hover:text-accent transition-colors py-8 text-left text-lg md:text-xl font-sans font-bold uppercase tracking-tight group">
                  <span className="flex items-center gap-6">
                    <span className="font-mono text-xs text-accent/60 tabular-nums">
                      {String(i + 1).padStart(2, '0')}
                    </span>
                    {faq.question}
                  </span>
                </AccordionTrigger>
                <AccordionContent className="text-foreground/80 font-serif leading-relaxed text-base md:text-lg pb-10 pl-12 md:pl-16 max-w-3xl">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>

        <div className="mt-16 pt-8 border-t border-border/10 flex flex-col md:flex-row justify-between items-start md:items-center gap-6">
          <p className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground">
            Last Updated: Q3 2024 
          </p>
          <div className="h-px flex-grow bg-border/10 hidden md:block mx-8" />
          <p className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground">
            Confidential Institutional Data
          </p>
        </div>
      </div>
    </section>;
}